<div class="form-group">
  @if(label()){
  <label class="mb-1" [ngClass]="{ 'required': isRequired() }">{{
    label() | translate
  }}</label>
  }

  <input
    appTrim
    [type]="type()"
    [placeholder]="label() | translate"
    [disabled]="isDisabled()"
    [value]="value"
    (input)="onInputChange($event)"
    (blur)="onTouched()"
    class="form-control"
    [class.is-invalid]="control?.invalid && control?.touched"
  />
  @if(control?.errors?.['required'] && control?.touched){
  <div class="invalid-feedback">
    {{ "input.required" | translate }}
  </div>
  } @if(control?.errors?.['pattern'] && control?.touched){
  <div class="invalid-feedback">
    {{ patternErrorMessage() | translate }}
  </div>
  }
</div>
